import { jsx as _jsx } from "react/jsx-runtime";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { Provider } from "../components/common/provider.js";
import { ListTableTreeSwitch } from "../components/options/listTableTreeSwitch.js";
/**
 * Add a switch to the list table if tax tree can be enabled for the current page.
 */ function addSwitchToListTable() {
    const container = $("<div/>").appendTo("#posts-filter > .tablenav.top > .alignleft.actions:not(.bulkactions)").css({
        float: "right"
    }).get(0);
    if (container) {
        createRoot(container).render(/*#__PURE__*/ _jsx(Provider, {
            children: /*#__PURE__*/ _jsx(ListTableTreeSwitch, {})
        }));
    }
}
export { addSwitchToListTable };
